"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _CardBody = _interopRequireDefault(require("./CardBody"));
var _CardTitle = _interopRequireDefault(require("./CardTitle"));
var _CardHeader = _interopRequireDefault(require("./CardHeader"));
var _CardFooter = _interopRequireDefault(require("./CardFooter"));
var _CardActions = _interopRequireDefault(require("./CardActions"));
var _CardInfos = _interopRequireDefault(require("./CardInfos"));
const Card = _ref => {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('card', className)
  }, children);
};
process.env.NODE_ENV !== "production" ? Card.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node
} : void 0;
Card.defaultProps = {
  className: undefined,
  children: undefined
};
var _default = exports.default = Object.assign(Card, {
  Body: _CardBody.default,
  Title: _CardTitle.default,
  Header: _CardHeader.default,
  Footer: _CardFooter.default,
  Actions: _CardActions.default,
  Infos: _CardInfos.default
});